import axios from '../config/axios';

export async function filtrosTimeLine() {
  return await axios.get('/pacientes/api/v1/obtenerColorEstilo');
}
export async function eventosFiltradosTimeLine(coleccion, documento, limite) {
  return await axios.post('/pacientes/api/v1/ultimosEventosPaciente',
    {
      coleccion,
      documento,
      limite,
    });
}


// WEBPACK FOOTER //
// ./src/apiService/request/TimeLine.js